"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _navigationUtils = require("../../utils/navigationUtils");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteFooterNew = function (_React$Component) {
  (0, _inherits3.default)(SiteFooterNew, _React$Component);

  function SiteFooterNew(props) {
    (0, _classCallCheck3.default)(this, SiteFooterNew);
    return (0, _possibleConstructorReturn3.default)(this, (SiteFooterNew.__proto__ || (0, _getPrototypeOf2.default)(SiteFooterNew)).call(this, props));
  }

  (0, _createClass3.default)(SiteFooterNew, [{
    key: "componentDidMount",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _navigationUtils.loadFooterWF)();

              case 2:
                if (!customElements.get("quixel-footer")) {
                  console.warn("[SiteFooterNew] quixel-footer loading issue");
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("quixel-footer", { locale: "en-US", domain: _config2.default.apiBaseUrl });
    }
  }]);
  return SiteFooterNew;
}(_react2.default.Component);

exports.default = SiteFooterNew;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteFooterNew/SiteFooterNew.jsx
// module id = 2659
// module chunks = 0